import ProfileModel from '../model/profile.model';
import EVENTS from '@shared/events';

class ProfileController {
  constructor(EventDispatcherService, HttpService, ProfileStore, CustomerApiService, NavbarService, $timeout, $translate, $sce, $scope) {
    'ngInject';

    this.EventDispatcherService = EventDispatcherService;
    this.HttpService = HttpService;
    this.NavbarService = NavbarService;
    this.ProfileStore = ProfileStore;
    this.$timeout = $timeout;
    this.$translate = $translate;
    this.CustomerApiService = CustomerApiService;
    this.image = null;
    this.$sce = $sce;
    this.$scope = $scope;
    this.$scope.renderingFile = false;
  }

  $onInit() {
    this.model = new ProfileModel();

    this.ProfileStore.getProfile().then((profile) => {
      this.model.id = profile.id;
      this.model.firstName = profile.firstName;
      this.model.lastName = profile.lastName;
      this.model.fullName = profile.full_name;
      this.model.currency.name = profile.currency.name;
      this.model.currency.code = profile.currency.code;
      this.model.country.name = profile.country.name;
      this.model.joinedDate = profile.joined_at;
      this.model.verifiedAt = profile.verified_at;
      this.model.dateOfBirth = profile.birthDate;
      this.model.email = profile.user.email;
      this.model.username = profile.user.username;
      this.model.contact = this.getPhoneNumber(profile.contacts);
      this.model.skype = profile.skype;
      this.model.enabled = profile.is_enabled;
      this.model.avatar = profile.avatar;

      this.loadAvatar();
    });

    this.updateModel();

    this.EventDispatcherService.addListener(EVENTS.AVATAR_UPDATED, event => {
      this.model.avatar = event.payload;

      this.loadAvatar();
    });
  }

  getPhoneNumber(contacts) {
    var contact = contacts.find(x => x.type === 'mobile');

    return contact ? contact.value : "";
  }

  updateModel() {
    return this.ProfileStore.getDashboardDetails().then((details) => {
      this.model.verifiedAt = details.others.verifiedAt;
    });
  }

  loadAvatar() {
    if (this.model.avatar && this.model.avatar.uploaded) {
      this.CustomerApiService.getAvatar(this.model.avatar.uploaded).then((fileUri) => {
        this.HttpService.$http.get(fileUri, {responseType: 'arraybuffer'}).then((s3data) => {
          const fileObj = new Blob([s3data], {type: 'application/binary'});
          this.image = this.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
        });
      });
    }    
  }
}

export default ProfileController;



// WEBPACK FOOTER //
// ./client/app/pages/profile/component/profile.controller.js